exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-review #checkout-review-table {\n  border-spacing: 0 0.5em !important;\n  border-collapse: separate !important;\n}\n.order-review__price .prices span {\n  font-size: 1rem;\n}\n", ""]);

// exports
